import React from 'react';

const HiddenField = ({ field }) => (
  <input type="hidden" id={`hidden-${field.key}`} name={field.field_name} value={field.value} />
)

export default HiddenField
